import { Box, Button, Checkbox, Tooltip } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import Flex from "../../../../../../../components/Flex";
import OutlineCard from "../../../../../../../components/OutlineCard";
import { getValueFromObj } from "../../../../../../../utils/utils";
import Text from "../../../../../../../components/Text";
import { ScrollArea } from "../../../../../../../components/ScrollBar";
import { PRESCRIPTION_MAPPER } from "../../../../patient/patient-list/patient-chart-new/order/order-utilsnew";
import { getTransPayload } from "../../../../patient/patient-list/patient-chart-new/order/prescription/OrderPrescriptionTableNew";

type RxCardProps = {
  med: any;
  onDelete: (id: string) => void;
  onEdit: (med: any) => void;
  selectable?: boolean;
  selected?: boolean;
  onToggleSelect?: (id: string) => void;
};

export const RxCard = ({
  med,
  onDelete,
  onEdit,
  selectable,
  selected,
  onToggleSelect,
}: RxCardProps) => {
  return (
    <OutlineCard
      style={{
        cursor: "pointer",
        width: "100%",
        minHeight: "92px",
        height: "100%",
      }}
      onClick={() => onEdit(getTransPayload(med))}
    >
      <Tooltip title="Click to Edit" followCursor>
        <Box
          sx={{
            height: "100%",
          }}
        >
          <Flex justifyContent={"space-between"}>
            <Flex gap={1} alignItems={"center"} mb={1}>
              {selectable && (
                <Checkbox
                  size="small"
                  checked={!!selected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={() => onToggleSelect?.(med?.uuid)}
                  sx={{ p: 0 }}
                />
              )}
              <Button
                sx={{
                  color: "#0097F0",
                  backgroundColor: "#CCECFF",
                  width: "52px",
                  height: "20px",
                }}
              >
                {PRESCRIPTION_MAPPER[med?.prescriptionFormType]}
              </Button>

              <Text fontWeight={"medium"}>
                {` ${getValueFromObj(med?.medication) || "-"} ${
                  med?.quantity || ""
                } ${med.unit || ""}`}
              </Text>
            </Flex>
            <ClearIcon
              onClick={() => onDelete(med?.uuid)}
              fontSize="small"
              sx={{ cursor: "pointer" }}
              color="error"
            />
          </Flex>
          <Box
            sx={{
              height: "100%",
            }}
          >
            <ScrollArea height={"100%"}>
              <Text>
                {` ${getValueFromObj(med?.medicationId) || "-"} ${
                  med?.quantity || ""
                } ${med.unit || ""} Refills-${
                  med?.refills ?? "-"
                } Directions to Patient- ${med?.directionToPatient}`}
              </Text>
            </ScrollArea>
          </Box>
        </Box>
      </Tooltip>
    </OutlineCard>
  );
};
